import { observable, action } from 'mobx';
import { saveAs } from 'file-saver';
import { http } from 'libs';
import { message } from 'antd';
// import moment from "moment";

class Store {
  @observable records = [];
  @observable record = {};
  @observable fetching = false;
  @observable formVisible = false;
  @observable selectDisable = false;
  //搜索条件
  @observable page = 1;
  @observable pageSize = 10;
  @observable pageTotal = 0;
  @observable projectNo = null;
  @observable orgId = null;
  @observable orgName = null;
  @observable status = null;
  @observable manageUserId = null;
  @observable manageUserName = null;
  @observable updateUserName = null;
  @observable applyUserName = null;
  @observable updateTime = null;


  // constructor() {
  //   initStore(this, makeAutoObservable)
  // }

  pageChange = (page, size) => {
    this.records = []
    this.page = page;
    this.pageSize = size;
    // localStorage.setItem('orderPageSize',size);
    this.fetchRecords()
}

  fetchRecords = () => {
    this.fetching = true;
    let query = {
      pageNo: this.page,
      pageSize: this.pageSize,
      projectNo: this.projectNo,
      orgName: this.orgName,
      status: this.status,
      manageUserName: this.manageUserName,
      applyUserName: this.applyUserName,
      updateTime1: this.updateTime&&this.updateTime[0],
      updateTime2: this.updateTime&&this.updateTime[1],
    }
    return http.post('/javaApi/front/project/list',{ 
      pageNo: this.page,
      pageSize: this.pageSize, 
      param: query,
    })
      .then(action('a', res => {
        console.log(res);
        this.records = res.data.result.data
        this.pageTotal = res.data.result.pageInfo.totalRows;
        // this.page_total_price = res.total_price || 0;
        // this.page_total_price_without_tax = res.total_price_without_tax || 0;
        // if (this.f_type === '1') {
        //     this.records = res.sale
        // } else if (this.f_type === '2') {
        //     this.records = res.lease
        // } else if (this.f_type === '3') {
        //     this.records = res.serve
        // } else {
        //     this.records = res.period
        // }
    }))
      .finally(action('b', () => this.fetching = false))
  };

  async exportLog(data) {
    const url = '/javaApi/front/export/projectExcel';
    const res = await http({
      url: url,
      method: 'get',
      params:data,
      responseType: 'arraybuffer',
      headers: {
        token: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return res;
  }

  onExport = () => {
    let query = {
      pageNo: this.page,
      pageSize: this.pageSize,
      projectNo: this.projectNo,
      orgName: this.orgName,
      status: this.status,
      manageUserName: this.manageUserName,
      applyUserName: this.applyUserName,
      updateTime1: this.updateTime&&this.updateTime[0],
      updateTime2: this.updateTime&&this.updateTime[1],
    }
    this.exportLog(query).then(res => {
      if (res) {
        let url = window.URL.createObjectURL(
          new Blob([res.data], {
            type:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          }),
        );
        saveAs(url,'项目列表.xls');
      } else {
        message.error('导出失败');
      }
    });
  }

  async fetchOrgList(value) {
    const query = {
      name: value,
    }
    return http.get('/api/customer/organization/',{ params: query })
    // .then((response) => response.json())
      .then((res) =>{
        console.log(res);
        if (res&&res.length) {
          return res.map((item) => ({
            label: item.name,
            value: item.id,
          }))
        }else{
          return []
        }
      }
      );
  }

  async fetchCustomerList(value,id) {
    if (id) {
      const query = {
        organization_id: id,
        name: value,
        
      }
      return http.get('/api/customer/customer/',{ params: query })
        .then((res) =>
          res.map((item) => ({
            ...item,
            label: item.name,
            value: item.id, 
          })),
        );
    }
  }

  onRowsChange = (rows, keys) => {
    console.log(rows, keys)
  }

  showForm = (info) => {
    this.record = info || {};
    this.formVisible = true
  }
}

export default new Store()